import React, { useState } from "react";
import style from "./style.module.css";
import useTranslation from "next-translate/useTranslation";
import Image from "next/image";
import { set_size } from "utils/getImageToDisplay";
import formatUrl from "utils/FormatUrl";

function AgenceCardV2(props) {
  const { t, lang } = useTranslation("agencesSection");
  const [displayPhone, setDisplayPhone] = useState(false);
  const buildLinkArab = () => {
    if (props.agent.agence[0]?.url) {
      let link1 = props.agent.agence[0].url.substr(0, 17);
      link1 = [link1, `${lang}/`].join("");
      let link2 = props.agent.agence[0].url.substr(
        17,
        props.agent.agence[0].url.length
      );
      return [link1, link2].join("");
    } else return null;
  };
  return (
    <a
      target="_blank"
      data-tracking="click"
      data-value="agent-name"
      href={formatUrl(buildLinkArab(), lang)}
      rel={
        buildLinkArab() &&
        (buildLinkArab().includes("list") ||
          buildLinkArab().includes("map") ||
          buildLinkArab().includes("?") ||
          buildLinkArab().includes("conditions") ||
          buildLinkArab().includes("contact"))
          ? "nofollow noopener noreferrer noindex"
          : "follow"
      }
    >
      <div className={style.cardContainer}>
        <div className={style.imageContainer}>
          <img
            className={style.user_image}
            src={
              props.agent.agence[0]?.user_image
                ? set_size(props.agent.agence[0].user_image, "250x250")
                : ""
            }
            alt={"Agence immobilière - agenz"}
            width={114}
            height={115}
          ></img>
        </div>
        <div className={style.contentContainer}>
          <div className={style.agentNameCon}>
            <span className={style.agent_name}>
              {props.agent.agence[0]?.nameEntreprise
                ? props.agent.agence[0].nameEntreprise
                : ""}
            </span>
            <span className={style.rating}>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.41873 1.17224C6.6103 0.621124 7.3897 0.621125 7.58127 1.17224L8.74031 4.50666C8.82482 4.74978 9.05171 4.91463 9.30905 4.91987L12.8384 4.99179C13.4218 5.00368 13.6626 5.74494 13.1977 6.09743L10.3846 8.23015C10.1795 8.38565 10.0928 8.65237 10.1674 8.89873L11.1896 12.2776C11.3586 12.8361 10.728 13.2942 10.2491 12.9609L7.3515 10.9446C7.14022 10.7976 6.85978 10.7976 6.6485 10.9446L3.75089 12.9609C3.27197 13.2942 2.64142 12.8361 2.81038 12.2776L3.83262 8.89873C3.90715 8.65237 3.82049 8.38565 3.61538 8.23015L0.802319 6.09743C0.337376 5.74494 0.578225 5.00368 1.16156 4.99179L4.69095 4.91987C4.94829 4.91463 5.17518 4.74978 5.25969 4.50666L6.41873 1.17224Z"
                  fill="#FD9539"
                />
              </svg>
              {"5"}
            </span>
            <span className={style.avis_numbers}>{`(${
              props.agent.nombre_avis
            } ${t("avis")})`}</span>
          </div>
          <p className={style.description}>
            {props.agent.agence[0]?.descriptionActivite
              ? props.agent.agence[0].descriptionActivite
              : ""}
          </p>
          <div className={style.agent_statics}>
            <div className={style.agent_vends}>
              <span>{props.agent.nombre_transactions}</span>
              <span>{t("Ventes récentes")}</span>
            </div>
            <div className={style.agent_annonces}>
              <span>{props.agent.nombre_annonces}</span>
              <span>{t("Annonces au Maroc")}</span>
            </div>
          </div>
          <div
            className={style.button_display_number}
            onClick={() => {
              setDisplayPhone(true);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M15.1316 11.1004C14.5716 11.0871 13.8667 11.0542 13.4213 10.976C12.9396 10.8907 12.36 10.7253 11.952 10.5982C11.632 10.4987 11.2836 10.5867 11.0462 10.8231L9.07555 12.7822C7.71378 12.0649 6.62311 11.2293 5.69956 10.3004C4.77067 9.37689 3.93511 8.28622 3.21778 6.92444L5.17689 4.95289C5.41333 4.71556 5.50133 4.36711 5.40178 4.04711C5.27556 3.64 5.10933 3.06044 5.02489 2.57867C4.94578 2.13333 4.91378 1.42844 4.89956 0.868444C4.888 0.384 4.49333 0 4.00889 0H0.888889C0.499556 0 0 0.291556 0 0.888889C0 4.92356 1.63556 8.77689 4.41422 11.5858C7.22311 14.3644 11.0764 16 15.1111 16C15.7084 16 16 15.5004 16 15.1111V11.9911C16 11.5067 15.616 11.112 15.1316 11.1004Z"
                fill="#4609F0"
              />
            </svg>
            {displayPhone ? (
              <a
                data-tracking="click"
                data-value="agent-phone"
                rel="noindex,nofollow"
                href={`tel:${props.agent.agence[0].phoneEntreprise}`}
              >
                {props.agent.agence[0].phoneEntreprise}
              </a>
            ) : (
              t("Afficher le téléphone")
            )}
          </div>
        </div>
      </div>
    </a>
  );
}

export default AgenceCardV2;
